import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import ShareModal, { ShareModalProps } from "./ShareModal";

export default function CapabilityShareLorebookModal(props: ShareModalProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.LorebookShareLink}>
      <ShareModal {...props} />
    </CapabilityGate>
  );
}
